export default __webpack_public_path__ + "static/media/3.b8867a7a.jpg";